import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../../utils';
import styles from './Loader.module.css';
const Loader = ({ size = 24, variant = 'default', className, }) => {
    const sizeString = typeof size === 'number' ? `${size}px` : size;
    return (_jsx("div", { className: classNames(styles.root, styles[variant], className), style: { width: sizeString, height: sizeString } }, void 0));
};
export default Loader;
